import { useContext, useState } from 'react';
import { ShipyardContext } from '../Context';

import './Tile.scss';

const tileColors = ['blue', 'pink', 'orange', 'green'];

/**Stylized div container
 * @param {object} props Incoming JSX attributes.
 * @param {string} [props.color] A string value denoting the color of the tile background.
 * @param {number} [props.count] An integer value to display. Defaults to zero.
 * @param {string} [props.title] A string value to display below the count data. Defaults to blank.
 * @returns {JSX.Element} Stylized div container
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/Tile.md Tile Documentation} for further information
 */

export default function Tile(props) {
    const { userSettings } = useContext(ShipyardContext);
    const [color] = useState(typeof props?.color === 'string' && tileColors.includes(props.color) ? props.color + '-tile' : 'default');
    const [title] = useState(typeof props?.title === 'string' ? props.title : null);
    const [count] = useState(
        typeof props?.count === 'number'
            ? props.count.toLocaleString(userSettings?.LanguagePreference ? userSettings.LanguagePreference : 'en-US')
            : 0
    );

    return (
        <div className="tile-container">
            <div className={(props.className ? props.className + ' tile' : 'tile') + ' ' + color}>
                <div className="tile-count-display">{count}</div>
                <div className="tile-title-display">{title}</div>
            </div>
        </div>
    );
}
